import { motion, useScroll, useSpring } from "framer-motion";

export function GrainOverlay() {
  return <div className="grain-overlay" aria-hidden="true" />;
}

export function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });
  return (
    <motion.div
      data-testid="scroll-progress-bar"
      style={{ scaleX }}
      className="fixed top-0 left-0 right-0 z-[70] h-[3px] origin-left bg-crimson"
    />
  );
}
